var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 44"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.25,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F0F4F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "support_agent"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_302_2602",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 41
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 20,
    y: 20.25,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_302_2602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "support_agent_2",
    d: "M40 55.25C39.5278 55.25 39.1319 55.0903 38.8125 54.7708C38.493 54.4514 38.3333 54.0556 38.3333 53.5833C38.3333 53.1111 38.493 52.7153 38.8125 52.3958C39.1319 52.0764 39.5278 51.9167 40 51.9167H51.6666V40.0833C51.6666 38.4722 51.3611 36.9583 50.75 35.5417C50.1389 34.125 49.3055 32.8889 48.25 31.8333C47.1944 30.7778 45.9583 29.9444 44.5416 29.3333C43.125 28.7222 41.6111 28.4167 40 28.4167C38.3889 28.4167 36.875 28.7222 35.4583 29.3333C34.0416 29.9444 32.8055 30.7778 31.75 31.8333C30.6944 32.8889 29.8611 34.125 29.25 35.5417C28.6389 36.9583 28.3333 38.4722 28.3333 40.0833V48.5833C28.3333 49.0556 28.1736 49.4514 27.8541 49.7708C27.5347 50.0903 27.1389 50.25 26.6666 50.25C25.75 50.25 24.9653 49.9236 24.3125 49.2708C23.6597 48.6181 23.3333 47.8333 23.3333 46.9167V43.5833C23.3333 42.9444 23.4861 42.3819 23.7916 41.8958C24.0972 41.4097 24.5 41.0139 25 40.7083L25.125 38.5C25.375 36.4722 25.9514 34.6389 26.8541 33C27.7569 31.3611 28.8819 29.9722 30.2291 28.8333C31.5764 27.6944 33.0903 26.8125 34.7708 26.1875C36.4514 25.5625 38.1944 25.25 40 25.25C41.8333 25.25 43.5903 25.5625 45.2708 26.1875C46.9514 26.8125 48.4583 27.7014 49.7916 28.8542C51.125 30.0069 52.243 31.3958 53.1458 33.0208C54.0486 34.6458 54.625 36.4583 54.875 38.4583L55 40.625C55.5 40.875 55.9028 41.2431 56.2083 41.7292C56.5139 42.2153 56.6666 42.75 56.6666 43.3333V47.1667C56.6666 47.7778 56.5139 48.3194 56.2083 48.7917C55.9028 49.2639 55.5 49.625 55 49.875V51.9167C55 52.8333 54.6736 53.6181 54.0208 54.2708C53.368 54.9236 52.5833 55.25 51.6666 55.25H40ZM35 43.5833C34.5278 43.5833 34.1319 43.4236 33.8125 43.1042C33.493 42.7847 33.3333 42.3889 33.3333 41.9167C33.3333 41.4444 33.493 41.0486 33.8125 40.7292C34.1319 40.4097 34.5278 40.25 35 40.25C35.4722 40.25 35.868 40.4097 36.1875 40.7292C36.5069 41.0486 36.6666 41.4444 36.6666 41.9167C36.6666 42.3889 36.5069 42.7847 36.1875 43.1042C35.868 43.4236 35.4722 43.5833 35 43.5833ZM45 43.5833C44.5278 43.5833 44.1319 43.4236 43.8125 43.1042C43.493 42.7847 43.3333 42.3889 43.3333 41.9167C43.3333 41.4444 43.493 41.0486 43.8125 40.7292C44.1319 40.4097 44.5278 40.25 45 40.25C45.4722 40.25 45.868 40.4097 46.1875 40.7292C46.5069 41.0486 46.6666 41.4444 46.6666 41.9167C46.6666 42.3889 46.5069 42.7847 46.1875 43.1042C45.868 43.4236 45.4722 43.5833 45 43.5833ZM30.0416 41C29.9305 39.3611 30.1597 37.875 30.7291 36.5417C31.2986 35.2083 32.0625 34.0764 33.0208 33.1458C33.9791 32.2153 35.0833 31.5 36.3333 31C37.5833 30.5 38.8333 30.25 40.0833 30.25C42.6111 30.25 44.7986 31.0486 46.6458 32.6458C48.493 34.2431 49.6111 36.2361 50 38.625C47.3889 38.5972 45.0278 37.8958 42.9166 36.5208C40.8055 35.1458 39.2083 33.3611 38.125 31.1667C37.6805 33.4167 36.743 35.4097 35.3125 37.1458C33.8819 38.8819 32.125 40.1667 30.0416 41Z",
    fill: "#7E8488"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaller);
export default __webpack_public_path__ + "static/media/caller.98017f74d3cd2e98fea4ece54fcde7e0.svg";
export { ForwardRef as ReactComponent };